import { i18n } from "@/plugins/i18n.plugin";
import { getTmoa } from "@/service/tmoa.service";
import { Estimation } from "@/types/estimation.type";
import { Filter } from "@/types/filter.type";
import { Parameter } from "@/types/parameter.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { Tmoa } from "@/types/tmoa.type";

export const removeDuplicate = (estimations: Estimation[]) => {
  const nombresUnicos = new Set();
  // Usamos el método filter para filtrar solo los objetos con nombres únicos
  const arraySinDuplicados = estimations.filter((obj) => {
    if (!nombresUnicos.has(obj.parameter?.code)) {
      nombresUnicos.add(obj.parameter?.code); // Añadimos el nombre al Set
      return true; // Mantenemos el objeto en el array filtrado
    }
    return false; // Descartamos el objeto si el nombre ya estaba en el Set
  });

  return arraySinDuplicados;
};

export const getTmoaEstimation = async (
  samplingPoint: SamplingPoint,
  value: number | undefined
): Promise<Tmoa | undefined> => {
  const samplingPointId = samplingPoint?.id;
  const filter: Filter = {
    fields: {
      "tmoa.samplingPointId": { operator: "equal", value: samplingPointId },
      "tmoa.value": { operator: "equal", value: value },
    },
  };
  return (await getTmoa(filter))[0];
};

export const findEstimation = (imageEstimations: Estimation[], param: Parameter) => {
  return imageEstimations?.find(
    (estimation) => estimation.parameter && estimation.parameter.code === param.code
  );
};

export const checkNameTmoa = (imageEstimations: Estimation[], param: Parameter) => {
  const estimation = findEstimation(imageEstimations, param);
  let value = "-";
  if (estimation?.value) {
    value = estimation.name ? estimation.name : `${estimation.value}`;
  }
  return value;
};

/**
 * Convertir una cadena en formato (###.##) a un número en formato cadena #.###,##
 * @param value
 * @returns
 */
export const formatNumber = (value: string | undefined) => {
  if (value == null) return "";

  return `${i18n.global.n(Number(value), "default")}`;
};

/**
 * Convertir una cadena en formato #.###,## a un número (###.##)
 * @param value
 * @returns
 */
export const parseNumber = (value: string) => {
  if (!value) return null;
  const numericValue = parseFloat(value.toString().replace(/\./g, "").replace(",", "."));

  return isNaN(numericValue) ? null : numericValue;
};
